import {kGlossaryTexts} from "../../../constants/texts";
import GlossaryDetailedScreenDefinition from "./GlossaryDetailedScreenDefinition";
import GlossaryDetailedScreenContext from "./GlossaryDetailedScreenContext";

export default function GlossaryDetailedScreenContent({term, currentTab}) {
    // Used in SingleKnowledgeScreen to display Knowledge
    // related content

    // BUILD
    if (currentTab === kGlossaryTexts.definitionTab)
        return <GlossaryDetailedScreenDefinition term={term} />
    if (currentTab === kGlossaryTexts.contextTab)
        return <GlossaryDetailedScreenContext term={term} />
    return null
}